// components
import { PATH_DASHBOARD } from '../../../routes/paths';
import SvgIconStyle from '../../../components/SvgIconStyle';

// ----------------------------------------------------------------------

const getIcon = (name) => <SvgIconStyle src={`/icons/${name}.svg`} sx={{ width: 1, height: 1 }} />;

const ICONS = {
  user: getIcon('ic_user'),
  ecommerce: getIcon('ic_ecommerce'),
  analytics: getIcon('ic_analytics'),
  dashboard: getIcon('ic_dashboard'),
};

const sidebarConfig = [
  // GENERAL
  // ----------------------------------------------------------------------
  {
    items: [
      // { title: 'Subadmin', path: PATH_DASHBOARD.subadmin.list, icon: ICONS.dashboard },
      { title: 'Seller', path: PATH_DASHBOARD.seller.list, icon: ICONS.analytics },
      { title: 'User', path: PATH_DASHBOARD.user.list, icon: ICONS.user },



    ],
  },

  
];

export default sidebarConfig;
